module.exports = __webpack_public_path__ + "media/images/paypal-logo-f3c6e31e309b69108ae84690c008f979.png";